module.exports = __webpack_public_path__ + "media/images/flags/4x3/mda-af4db83b67b1f34f882910745c93f58d.svg";